import Vue from 'vue'
import Router from 'vue-router'

import welcome from '@/components/welcome'
import questions from '@/components/operational/questions'
import questionstree from '@/components/operational/questionstree'
import personalareausers from '@/components/operational/personalareausers'
import calendar from '@/components/personalarea/calendar'
import resume from '@/components/personalarea/resume'
import docviewer from '@/components/personalarea/docviewer'
import results from '@/components/personalarea/results'
import vacancy from '@/components/personalarea/vacancy'
import vacancyview from '@/components/personalarea/vacancyview'
import vacancysolution from '@/components/personalarea/vacancysolution'
import vacancyreport from '@/components/personalarea/vacancyreport'
import notifications from '@/components/personalarea/notifications'
import legalacts from '@/components/registry/legalacts'
import legalact from '@/components/registry/legalact'
import contestwelcome from '@/components/contest/welcome'
import scenariowelcome from '@/components/contest/scenariowelcome'
import scenarioexit from '@/components/contest/scenarioexit'
import testwelcome from '@/components/contest/testwelcome'
import testexit from '@/components/contest/testexit'
import question from '@/components/contest/question'
import report from '@/components/contest/report'
import notfound from '@/components/common/notfound'
import notauthorized from '@/components/common/notauthorized'
import forbidden from '@/components/common/forbidden'
import internalservererror from '@/components/common/internalservererror'
import callback from '@/components/auth/callback'
import silentRenew from '@/components/auth/silent-renew'

import config from '../appsettings.js'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      path: config.WELCOME_URL, name: 'welcome', component: welcome
    },
    {
      path: config.FORBIDDEN_URL, name: 'Forbidden', component: forbidden
    },
    {
      path: config.NOT_AUTHORIZED_URL, name: 'Unauthorized', component: notauthorized
    },
    {
      path: config.INTERNAL_SERVER_ERROR_URL, name: 'Internal Server Error', component: internalservererror
    },
    {
      path: '/calendar', name: 'calendar', component: calendar
    },
    {
      path: config.RESUME_URL + '/:guid', name: 'candidatesview', component: resume, props: true
    },
    {
      path: config.RESUME_URL, name: 'resume', component: resume
    },
    {
      path: config.DOC_VIEWER_URL + '/:doctype', name: 'docviewer', component: docviewer, props: true
    },
    {
      path: config.DOC_VIEWER_URL + '/:doctype/uid/:uid', name: 'docviewerwithuid', component: docviewer, props: true
    },
    {
      path: '/results', name: 'results', component: results
    },
    {
      path: config.VACANCY_URL, name: 'vacancy', component: vacancy
    },
    {
      path: config.VACANCY_URL + '/:vv', name: 'vacancyview', component: vacancyview, props: true
    },
    {
      path: config.VACANCY_URL + '/view/:vv', name: 'vacancyreadonlyview', component: vacancyview, props: true
    },
    {
      path: '/vacancyreport', name: 'vacancyreport', component: vacancyreport
    },
    {
      path: '/vacancysolution/:vacancy/candidate/:candidate', name: 'vacancysolution', component: vacancysolution, props: true
    },
    {
      path: config.LEGAL_ACTS_URL, name: 'legalacts', component: legalacts
    },
    {
      path: config.LEGAL_ACT_URL + ':la', name: 'legalact', component: legalact, props: true
    },
    {
      path: '/contest-welcome', name: 'contestwelcome', component: contestwelcome
    },
    {
      path: config.SCENARIO_WELCOME_URL, name: 'scenariowelcome', component: scenariowelcome
    },
    {
      path: '/scenario-exit', name: 'scenarioexit', component: scenarioexit
    },
    {
      path: '/test-welcome', name: 'testwelcome', component: testwelcome
    },
    {
      path: '/test-exit', name: 'testexit', component: testexit
    },
    {
      path: '/report', name: 'report', component: report
    },
    {
      path: '/question', name: 'question', component: question
    },
    {
      path: config.NOTIFICATIONS_URL, name: 'notifications', component: notifications
    },
    {
      path: '/questions', name: 'questions', component: questions
    },
    {
      path: '/questionstree', name: 'questionstree', component: questionstree
    },
    {
      path: '/personalareausers', name: 'personalareausers', component: personalareausers
    },
    {
      path: '/auth/callback', name: 'auth-callback', component: callback
    },
    {
      path: '/auth/silent-renew', name: 'silent-renew', component: silentRenew
    },
    {
      path: '*', name: 'Page Not Found', component: notfound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js